import React from 'react'
import './header.scss'

const header = () => {
  return (
    <div className='container-header'>
        <div className='title-header'>
            CITRALAND UTARA SURABAYA
        </div>
    </div>
  )
}

export default header;